import { render, staticRenderFns } from "./Betting.vue?vue&type=template&id=07c175b2&scoped=true"
import script from "./Betting.vue?vue&type=script&lang=js"
export * from "./Betting.vue?vue&type=script&lang=js"
import style0 from "./Betting.vue?vue&type=style&index=0&id=07c175b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c175b2",
  null
  
)

export default component.exports